import { useIntl } from 'react-intl';
import ProgressBar from './ProgressBar';

const OnboardingHeader = ({ currentStep, totalSteps }) => {
  const intl = useIntl();

  return (
    <div style={{ padding: '24px 48px' }}>
      <h4 style={{ marginBottom: 12, color: '#0e0e0fff' }}>
        <strong>
          {intl.formatMessage({ id: 'bemVindoActio' })} 👋
        </strong>
      </h4>

      <ProgressBar total={totalSteps} current={currentStep + 1} />
    </div>
  );
};

export default OnboardingHeader;
